import LocalShippingIcon from '@material-ui/icons/LocalShipping';

import List from './List';

export default {
  list: List,
  icon: LocalShippingIcon,
};
